module.exports = __webpack_public_path__ + "img/evaluate-level1.16bafa4e.png";